import { FormProvider, UseFormReturn } from 'react-hook-form';
import { CaseForm } from 'queries/cases/types';
import { EvidenceTabs } from './EvidenceTabs';

interface EvidenceTabsWithFormContextProps {
  assetId: string;
  caseId: string;
  formMethods: UseFormReturn<CaseForm>;
}

export const EvidenceTabsWithFormContext = ({
  assetId,
  caseId,
  formMethods,
}: EvidenceTabsWithFormContextProps) => {
  const { handleSubmit } = formMethods;

  return (
    <FormProvider {...formMethods}>
      <EvidenceTabs assetId={assetId} caseId={caseId} handleSubmit={handleSubmit} />
    </FormProvider>
  );
};
